import { Routes, Route } from 'react-router-dom';
import PrivateRoute from '../components/common/PrivateRoute.js';
import Dashboard from '../components/Products/FoodserviceForm/pages/Dashboard.tsx';

const FoodserviceFormRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute product="foodservice_form">
            <Dashboard />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default FoodserviceFormRoutes;
